"use client";

import HomeCarouselSection from "@/components/home/HomeCarouselSection";
import RentalCard from "@/components/card/RentalCard";
import PosterLandscapeCardSkeleton from "@/components/skeletons/card/PosterLandscapeCardSkeleton";
import { useRentalsCarousel } from "@/hooks/rental/useRental";
import { RentalCarouselItem } from "@/components/main-services/rentals/rental.type";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { useInView } from "@/hooks/useObserver";

interface RentalCarouselProps {
  title: string;
  icon?: string;
  href?: string;
  vehicleType?: RentalCarouselItem["vehicleType"];
}

const RentalCarousel = ({
  title,
  icon,
  href,
  vehicleType,
}: RentalCarouselProps) => {
  const [containerRef, inView] = useInView("300px");
  const isMdUp = useMediaQuery("(min-width: 768px)");
  const { data: rentals, isFetching, isError } = useRentalsCarousel(inView);

  const items = vehicleType
    ? rentals?.items?.filter(
        (item: { vehicleType: string }) => item.vehicleType === vehicleType,
      )
    : rentals?.items;

  if (inView && !isFetching && items?.length === 0) return null;

  return (
    <div ref={containerRef}>
      <HomeCarouselSection<RentalCarouselItem>
        title={title}
        icon={icon}
        href={href}
        items={items}
        isFetching={isFetching}
        isError={isError}
        itemsPerCol={3}
        getKey={(rental) => rental.id}
        renderItem={(rental) => (
          <RentalCard rental={rental} layout={isMdUp ? "row" : "stacked"} />
        )}
        renderSkeleton={() => <PosterLandscapeCardSkeleton />}
      />
    </div>
  );
};

export default RentalCarousel;
